<template>
  <section class="section">
    <button
      class="button cashboxbutton tooltip"
      :class="openbox ? 'is-link' : 'is-danger'"
      v-show="hasBoxOfCash"
      data-tooltip="Cudre Caja"
      @click="clicktocashbox"
    >
      <span class="icon">
        <i class="material-icons">point_of_sale</i>
      </span>
    </button>
    <div class="container">
      <h1 class="title">
        {{empresa.nombrec}}
        <small
          class="title is-5"
        >{{empresa.nit | textnumber()}}{{empresa.nit | dverif()}}</small>
        <small class="subtitle is-7">{{empresa.nombre}}</small>
      </h1>
      <div class="columns">
        <div class="column">
          <div class="field is-fullwidth has-addons">
            <div class="control">
              <a class="button is-light is-medium" @click="launchModal">
                <span class="icon is-medium">
                  <i class="material-icons">list_alt</i>
                </span>
              </a>
            </div>
            <div class="control is-expanded has-icons-left">
              <input
                id="c1"
                @blur="blurFunction('c1')"
                @keydown="keyfunction($event,'c1')"
                @focus="focusfunction('c1')"
                class="input is-medium is-fullwidth"
                type="text"
                v-model="textInputs.c1"
                placeholder="Comprobante"
                autocomplete="off"
              />
              <span v-show="editsel" class="icon is-small is-left">
                <i class="material-icons">edit</i>
              </span>
              <span v-show="!editsel" class="icon is-small is-left">
                <i class="material-icons">control_camera</i>
              </span>
            </div>
          </div>
        </div>
        <div class="column">
          <fieldset :disabled="true">
            <div class="field">
              <div class="control">
                <input
                  class="input is-medium"
                  v-model="textInputs.c2"
                  type="text"
                  placeholder="Documento"
                />
              </div>
            </div>
          </fieldset>
        </div>
        <div class="column">
          <div class="field has-addons">
            <p class="control">
              <input
                class="input is-medium"
                id="c3"
                @blur="blurFunction('c3')"
                @keydown="keyfunction($event,'c3')"
                type="number"
                placeholder="Fecha"
                v-model="textInputs.c3"
                :disabled="!editday"
              />
            </p>
            <p class="control">
              <a
                class="button is-medium is-static"
              >{{comundata.periodo ? comundata.periodo : 'xx' | periodo()}}</a>
            </p>
          </div>
        </div>
      </div>
      <div v-show="existborrador" class="columns">
        <div class="column">
          <div class="notification is-link">
            <h1 class="title">Existe un borrador</h1>
            <h1 class="subtitle">Existe un borrador que no ha sido guardado, ¿desea cargarlo?</h1>
            <button
              class="button is-info is-inverted is-outlined is-large"
              @click="cargarborrador"
            >Si</button>
            <button
              class="button is-info is-inverted is-outlined is-large"
              @click="existborrador = false, borrador = null"
            >No</button>
            <button
              class="button is-info is-inverted is-outlined is-large"
              @click="eliminarborrador"
            >Eliminar borrador</button>
          </div>
        </div>
      </div>
      <div v-show="viewReg" class="columns">
        <div class="column">
          <div class="notification">
            <h1 class="title">yungol es ágil y fácil de usar.</h1>
            <h2 class="subtitle">
              <br />Te recomendamos utilizar estos atajos para navegar más rápido en nuestro sistema.
            </h2>
            <div class="content">
              <ul>
                <li>
                  <strong>F3</strong> Con esta tecla puedes desplegar el menú con las opciones. O puedes dar clic directamente en este icono
                  <span
                    class="icon"
                  >
                    <i class="material-icons icon-lista">list_alt</i>
                  </span>
                </li>
                <li>
                  <strong>F2</strong> Con esta tecla puedes editar los textos en la celda actual.
                </li>
                <li>
                  <span class="icon">
                    <i class="material-icons">keyboard_return</i>
                  </span>
                  Con enter puedes desplazarte rápidamente hacia la columna siguiente, también puedes hacerlo con las flechas del teclado.
                </li>
                <li>
                  <strong>F10</strong>
                  Con esta tecla puedes guardar rápidamenten el documento.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!viewReg">
        <y-estructura
          v-if="comundata.comprobante.estructura === 'inventario' || comundata.comprobante.estructura === 'comercial'"
          :comundata="comundata"
          :borrador="borrador"
          :guardando="guardando"
          :turno="turno"
          @notifyguardado="notifyguardado"
          @f10guardar="lanzaguardar"
        ></y-estructura>
        <y-estructurafrapventa
          v-if="comundata.comprobante.estructura === 'factura'"
          :comundata="comundata"
          :borrador="borrador"
          :turno="turno"
          @notifyguardado="notifyguardado"
          @f10guardar="lanzaguardar"
          @cancelar='cancelar'
        ></y-estructurafrapventa>
      </div>
      <div v-if="!viewReg1" class="margin-top buttons">
        <button class="button is-primary is-medium" @click="lanzaguardar" id="botonGuardar">
          <span class="icon is-medium">
            <i class="material-icons">save</i>
          </span>&nbsp; Guardar F10
        </button>
        <button class="button is-light is-medium" @click="guardaimprime">
          <span class="icon is-medium">
            <i class="material-icons">print</i>
          </span>&nbsp; Guardar e Imprimir
        </button>
        <button class="button is-warning is-medium" @click="cancelar">
          <span class="icon is-medium">
            <i class="material-icons">cancel</i>
          </span>&nbsp; Cancelar
        </button>
      </div>
    </div>
    <div v-show="false">
      <div v-if="resultRegistros.length > 0">
        <y-printcomercial
          v-if="resultRegistros[0].valor && data.comprobante.esfactura==false && data.comprobante.estructura === 'comercial'"
          id="printable"
          :data="data"
          :total="total"
          :registros="resultRegistros"
        ></y-printcomercial>
        <y-printcomercialfactura
          v-if="resultRegistros[0].valor && data.comprobante.esfactura && data.comprobante.estructura === 'comercial'"
          id="printable"
          :data="data"
          :total="total"
          :registros="resultRegistros"
          :iva="iva"
          :cliente="cliente"
          :subtotal="subtotal"
          :vencimiento="vencimiento"
        ></y-printcomercialfactura>
      </div>
    </div>
    <y-modalcashbox
      :show="showmodalcashbox"
      @closemodal="clicktocashbox"
      :turno="turno"
      @resultturno="resultturno"
    ></y-modalcashbox>
  </section>
</template>
<script>
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";
import functions from "@/helpers/functions";
import yEstructura from "@/components/registrar/Estructura.vue";
import yEstructurafrapventa from "@/components/registrar/Estructurafrapventa.vue";
import yPrintcomercial from "@/components/prints/Printcomercial.vue";
import yPrintcomercialfactura from "@/components/prints/Printcomercialfactura.vue";
import yModalcashbox from "@/components/modals/Modalcashbox.vue";
import { setTimeout } from "timers";
function getSum(t, k, v) {
  let debito = 0;
  let credito = 0;
  if (parseInt(k.tipo) === 1) {
    debito = k.valor;
    credito = 0;
  } else {
    debito = 0;
    credito = k.valor;
  }
  t.debito = parseInt(t.debito) + parseInt(debito);
  t.credito = parseInt(t.credito) + parseInt(credito);
  return t;
}

function sumarDias(fecha, dias) {
  fecha.setDate(fecha.getDate() + dias);
  return fecha;
}

export default {
  data() {
    return {
      editday: true,
      showmodalcashbox: false,
      openbox: false,
      turno: {},
      comundata: {
        comprobante: null,
        numDoc: null,
        dia: null,
        periodo: null,
        cuentasdoc: null,
        ccostos: null,
      },
      comprobantes: [],
      comprobanteModal: [],
      textInputs: {
        c1: "",
        c2: null,
        c3: null,
      },
      editsel: false,
      existborrador: false,
      borrador: null,
      guardando: false,
      isprint: false,
      resultRegistros: [],
      data: {},
      total: 0,
      vencimiento: null,
      iva: 0,
      subtotal: 0,
      cliente: null,
    };
  },
  computed: {
    ...mapState([
      "user",
      "empresa",
      "idtoken",
      "resultDatamodal",
      "nits",
      "cuentas",
      "productos",
      "bodegas",
      "vendedores",
    ]),
    viewReg() {
      if (this.comundata.comprobante) {
        return false;
      } else {
        return true;
      }
    },

    viewReg1() {
      if (!this.viewReg) {
        if (this.comundata.comprobante.estructura === "factura") {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    hasBoxOfCash() {
      return (
        this.empresa && this.empresa.modulos && this.empresa.modulos.cuadrecaja
      );
    },
  },
  methods: {
    resultturno(turno) {
      if (turno._id) {
        this.turno = turno;
        this.turno.fecha = functions.formatDate(new Date(this.turno.fecha));
        this.openbox = true;
      } else {
        this.openbox = false;
        this.turno = {};
        this.turno.responsable = this.user.displayName;
        this.turno.fecha = functions.formatDate(new Date());
      }
      this.clicktocashbox();
    },
    clicktocashbox() {
      if (this.showmodalcashbox) {
        this.showmodalcashbox = false;
      } else {
        this.showmodalcashbox = true;
      }
    },
    guardaimprime() {
      this.guardando = true;
      this.isprint = true;
    },
    cancelar() {
      this.isprint = false;
      let temporal = localStorage.getItem("temporal");
      temporal = JSON.parse(temporal);
      if (temporal) {
        this.existborrador = true;
        this.borrador = temporal;
      } else {
        this.existborrador = false;
        this.borrador = null;
      }
      this.guardando = false;
      this.traeComprobantes(this);
      this.textInputs.c1 = "";
      this.textInputs.c2 = null;
      this.textInputs.c3 = null;
      this.comundata.comprobante = null;
      this.comundata.numDoc = null;
      this.comundata.dia = null;
      this.comundata.periodo = null;
      this.comundata.cuentasdoc = null;
      document.getElementById("c1").focus();
    },
    notifyguardado(payload) {
      this.guardando = false;
      const _this = this;
      if (payload.guardo) {
        if (this.isprint) {
          this.isprint = false;
          this.data = {
            comprobante: this.comundata.comprobante,
          };

          if (_this.data.comprobante.estructura === "contable") {
            _this.resultRegistros = payload.result.map((e) => e);
            _this.total = payload.result.reduce(getSum, {
              debito: 0,
              credito: 0,
            });
          } else {
            _this.resultRegistros = [];
            payload.result.forEach(function (key) {
              if (_this.data.comprobante.cuenta === key.idcuenta._id) {
                _this.total = key;
              } else {
                _this.resultRegistros.push(key);
              }
            });
            _this.resultRegistros = functions.order(
              _this.resultRegistros,
              "orden"
            );
            if (_this.data.comprobante.esfactura) {
              const d = new Date(_this.total.fecha);
              const d1 = parseInt(_this.data.comprobante.vencimiento);
              _this.vencimiento = sumarDias(d, d1);
              let registros = _this.resultRegistros;
              _this.resultRegistros = [];
              _this.iva = 0;
              _this.subtotal = 0;
              for (var i = 0; i < payload.result.length; i++) {
                if (payload.result[i].idcuenta.tercero === true) {
                  _this.cliente = payload.result[i].idnit;
                  if (payload.result[i].idnit.ciudad) {
                    let largo = payload.result[i].idnit.ciudad.length;
                    _this.cliente.ciudad = payload.result[
                      i
                    ].idnit.ciudad.substr(9, largo - 9);
                  } else {
                    _this.cliente.ciudad = false;
                  }
                  break;
                }
              }
              let iva = [];
              registros.forEach(function (key, val) {
                if (key.idcuenta.codigo.substr(0, 2) === "24") {
                  iva.push(key);
                } else {
                  _this.resultRegistros.push(key);
                }
              });
              if (iva.length > 0) {
                iva.forEach(function (key) {
                  if (_this.total.tipo === key.tipo) {
                    _this.iva = _this.iva - key.valor;
                  } else {
                    _this.iva = _this.iva + key.valor;
                  }
                });
              }
              _this.resultRegistros.forEach(function (key) {
                if (_this.total.tipo === key.tipo) {
                  _this.subtotal = _this.subtotal - key.valor;
                } else {
                  _this.subtotal = _this.subtotal + key.valor;
                }
              });
            }
          }
          setTimeout(function () {
            _this.$print("printable", {
              name: `${_this.data.comprobante.nombre} - ${_this.resultRegistros[0].documento} - ${_this.empresa.mesc}`,
            });
          }, 10);
        }
        this.traeComprobantes(this);
        localStorage.removeItem("temporal");
        this.borrador = null;
        this.existborrador = false;
        this.textInputs.c1 = "";
        this.textInputs.c2 = null;
        this.textInputs.c3 = null;
        this.comundata.comprobante = null;
        this.comundata.numDoc = null;
        this.comundata.dia = null;
        this.comundata.periodo = null;
        this.comundata.cuentasdoc = null;
        document.getElementById("c1").focus();
      }
    },
    lanzaguardar() {
      this.guardando = true;
    },
    launchModal() {
      this.$store.commit("launchModal", {
        title: "Seleccione el Comprobante",
        oktext: "Aceptar",
        canceltext: "Cancelar",
        titleTable: [
          { cod: "codigo", name: "Código" },
          { cod: "nombre", name: "Nombre" },
        ],
        table: this.comprobanteModal,
        result: "c1",
      });
    },
    async findturno() {
      try {
        const result = await apiServices.get(`/turnoactual`);
        if (result.data) {
          this.openbox = true;
          this.turno = result.data;
          this.turno.fecha = functions.formatDate(new Date(this.turno.fecha));
        } else {
          this.openbox = false;
          this.turno = {};
          this.turno.responsable = this.user.displayName;
          this.turno.fecha = functions.formatDate(new Date());
        }
      } catch (err) {
        console.log(err);
      }
    },
    async traeComprobantes(_this) {
      let result;
      try {
        result = await apiServices.get(`/comprobantes`);
        _this.comprobanteModal = [];
        _this.comprobantes = result.data;
        result.data.forEach((el) => {
          const d = {};
          d.codigo = el.codigo;
          d.nombre = el.nombre;
          d.id = el._id;
          d.selected = false;

          if (el.estructura !== "contable") {
            // que aparezcan todos los comprobantes menos los contables.
            _this.comprobanteModal.push(d);
          }
        });
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema cargando los comprobantes.",
          type: "is-danger",
          position: "top-center",
        });
        console.log("ocurrio un problema cargando los comprobantes", err);
      }
    },
    async traeCuentas(_this) {
      let result;
      try {
        result = await apiServices.get(`/cuentas/reg`);
        _this.$store.commit("refreshCuentas", result.data);
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema cargando las cuentas.",
          type: "is-danger",
          position: "top-center",
        });
        console.log("ocurrio un problema cargando las cuentas", err);
      }
    },
    async traeNits(_this) {
      let result;
      try {
        result = await apiServices.get(`/nits`);
        _this.$store.commit("refreshNits", result.data);
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema cargando los terceros.",
          type: "is-danger",
          position: "top-center",
        });
        console.log("ocurrio un problema cargando los terceros", err);
      }
    },
    async traeCCostos(_this) {
      let result;
      try {
        result = await apiServices.get(`/ccostos`);
        _this.comundata.ccostos = result.data;
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema cargando los centros de costos.",
          type: "is-danger",
          position: "top-center",
        });
        console.log("ocurrio un problema cargando los centros de costos", err);
      }
    },
    async traeProductos(_this) {
      let result;
      try {
        result = await apiServices.get(`/productos`);
        _this.$store.commit("refreshProductos", result.data);
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema cargando los productos.",
          type: "is-danger",
          position: "top-center",
        });
        console.log("ocurrio un problema cargando los productos", err);
      }
    },
    async traeBodegas(_this) {
      let result;
      try {
        result = await apiServices.get(`/bodegas`);
        _this.$store.commit("refreshBodegas", result.data);
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema cargando las bodegas.",
          type: "is-danger",
          position: "top-center",
        });
        console.log("ocurrio un problema cargando las bodegas", err);
      }
    },
    async traeCuentasDoc(_this, comprobanteid) {
      let result;
      try {
        result = await apiServices.get(`/cuentas/dcto/${comprobanteid}`);
        _this.comundata.cuentasdoc = result.data.map((e) => {
          const d = {
            codigo: e.cuenta.codigo,
            id: e.cuenta._id,
            nombre: e.nombrep,
            selected: false,
          };
          return d;
        });
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema cargando las cuentas del documento.",
          type: "is-danger",
          position: "top-center",
        });
        console.log(
          "ocurrio un problema cargando las cuentas del documento",
          err
        );
      }
    },
    async traeVendedores(_this) {
      let result;
      try {
        result = await apiServices.get(`/vendedores`);
        _this.$store.commit("refreshVendedores", result.data);
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema cargando los vendedores.",
          type: "is-danger",
          position: "top-center",
        });
        console.log("ocurrio un problema cargando los vendedores", err);
      }
    },
    focusfunction(el) {
      if (el === "c1") {
        this.editday = true;
      }
    },
    blurFunction(el) {
      let text = this.textInputs[el];
      if (el === "c1") {
        const indice = text.indexOf(" - ");
        if (text.indexOf(" - ") !== -1) {
          text = text.substr(0, indice);
        }
        const comprobante = functions.findData(
          this.comprobantes,
          text,
          "codigo"
        );
        if (comprobante) {
          const periodo = {
            year: new Date().getFullYear(),
            mes: new Date().getMonth(),
            dia: new Date().getDate(),
          };
          let lengthtextmes = periodo.mes + 1;
          console.log('el mes es',lengthtextmes);
          lengthtextmes = lengthtextmes.toString().length;
          console.log('y el largo es',lengthtextmes);

          if (lengthtextmes === 1) {
            periodo.periodo = `${periodo.year}0${periodo.mes + 1}`;
          } else {
            periodo.periodo = `${periodo.year}${periodo.mes + 1}`;
          }
          if (this.hasBoxOfCash && comprobante.estructura === "factura") {
            if (this.turno._id) {
              this.comundata.dia = periodo.dia;
              this.comundata.periodo = periodo.periodo;
              this.textInputs["c3"] = periodo.dia;
              this.editday = false;
              setTimeout(function () {
                document.getElementById("inputEncabezado").focus();
              }, 5);
              this.textInputs[
                el
              ] = `${comprobante.codigo} - ${comprobante.nombre}`;
              this.textInputs["c2"] = comprobante.consecutivo;
              this.comundata.comprobante = comprobante;
              this.comundata.numDoc = comprobante.consecutivo;
              this.traeCuentasDoc(this, comprobante._id);
            } else {
              // aqui va un error donde diga que primero debe abrir la caja
              this.comundata.comprobante = null;
              this.textInputs[el] = "";
              this.$store.dispatch("notify", {
                message: "Debe abrir la caja primero.",
                type: "is-danger",
                position: "top-center",
              });
            }
          } else if (
            this.hasBoxOfCash &&
            comprobante.estructura === "inventario"
          ) {
            if (this.turno._id) {
              this.comundata.dia = periodo.dia;
              this.comundata.periodo = periodo.periodo;
              this.textInputs["c3"] = periodo.dia;
              this.editday = false;
              setTimeout(function () {
                document.getElementById("inputReg").focus();
              }, 5);
              this.textInputs[
                el
              ] = `${comprobante.codigo} - ${comprobante.nombre}`;
              this.textInputs["c2"] = comprobante.consecutivo;
              this.comundata.comprobante = comprobante;
              this.comundata.numDoc = comprobante.consecutivo;
              this.traeCuentasDoc(this, comprobante._id);
            } else {
              // aqui va un error donde diga que primero debe abrir la caja
              this.comundata.comprobante = null;
              this.textInputs[el] = "";
              this.$store.dispatch("notify", {
                message: "Debe abrir la caja primero.",
                type: "is-danger",
                position: "top-center",
              });
            }
          } else {
            this.comundata.periodo = this.empresa.mesc;
            this.editday = true;
            this.textInputs[
              el
            ] = `${comprobante.codigo} - ${comprobante.nombre}`;
            this.textInputs["c2"] = comprobante.consecutivo;
            this.comundata.comprobante = comprobante;
            this.comundata.numDoc = comprobante.consecutivo;
            this.traeCuentasDoc(this, comprobante._id);
          }
        } else {
          if (text === "") {
            this.comundata.comprobante = null;
          } else {
            this.comundata.comprobante = null;
            this.textInputs[el] = "";
            this.$store.dispatch("notify", {
              message: "El comprobante no existe.",
              type: "is-warning",
              position: "top-center",
            });
          }
        }
      }
      if (el === "c3") {
        text = parseInt(text);

        if (isNaN(text)) {
          text = 1;
        } else {
          if (text > 31 || text < 1) {
            text = 1;
          }
        }
        this.textInputs["c3"] = text;
        this.comundata.dia = text;
      }
    },
    keyfunction(e, id) {
      if (e.keyCode === 113) {
        if (this.editsel) {
          this.editsel = false;
        } else {
          this.editsel = true;
        }
      }
      if (id === "c1") {
        if (e.keyCode === 13) {
          e.preventDefault();
          document.getElementById("c3").focus();
        }
        if (e.keyCode === 39) {
          if (!this.editsel) {
            e.preventDefault();
            document.getElementById("c3").focus();
          }
        }
        if (e.keyCode === 114) {
          e.preventDefault();
          this.launchModal();
        }
      }
      if (id === "c3") {
        if (e.keyCode === 37) {
          e.preventDefault();
          document.getElementById("c1").focus();
        }
        if (e.keyCode === 13) {
          e.preventDefault();
          if (this.comundata.comprobante) {
            if (this.comundata.comprobante.estructura === "factura") {
              document.getElementById("inputEncabezado").focus();
            } else {
              document.getElementById("inputReg").focus();
            }
            // ir a la primera celda del registro
          } else {
            document.getElementById("c1").focus();
          }
        }
      }
    },
    cargarborrador() {
      this.textInputs.c1 = this.borrador.comprobante.codigo;
      this.textInputs.c3 = this.borrador.dia;
      this.blurFunction("c1");
      this.blurFunction("c3");
      this.existborrador = false;
      if (this.borrador.comprobante.estructura === "factura") {
        setTimeout(function () {
          document.getElementById("inputEncabezado").focus();
        }, 5);
      } else if (this.borrador.comprobante.estructura === "comercial") {
        setTimeout(function () {
          document.getElementById("inputReg").focus();
        }, 5);
      }
    },
    eliminarborrador() {
      localStorage.removeItem("temporal");
      this.borrador = null;
      this.existborrador = false;
    },
  },
  created() {
    if (this.idtoken) {
      this.traeComprobantes(this);
      if (this.cuentas.length === 0) {
        this.traeCuentas(this);
      }
      if (this.nits.length === 0) {
        this.traeNits(this);
      }

      if (this.productos.length === 0) {
        this.traeProductos(this);
      }
      if (this.bodegas.length === 0) {
        this.traeBodegas(this);
      }
      if (this.vendedores.length === 0) {
        this.traeVendedores(this);
      }
      this.traeCCostos(this);
      let temporal = localStorage.getItem("temporal");
      temporal = JSON.parse(temporal);
      if (temporal) {
        this.existborrador = true;
        this.borrador = temporal;
      }
      if (this.hasBoxOfCash) {
        this.findturno();
      }
    }
  },
  mounted() {
    document.getElementById("c1").focus();
  },
  watch: {
    empresa(nv, ov) {
      // si cambia la empresa reinicio el registro
      if (ov._id !== "no id") {
        if (ov._id !== nv._id) {
          this.cancelar();
          if (this.hasBoxOfCash) {
            this.findturno();
          }
        }
      } else {
        if (this.hasBoxOfCash) {
          this.findturno();
        }
      }
    },
    resultDatamodal(newv, oldv) {
      if (newv.result) {
        if (newv.result.substr(0, 1) === "c") {
          // esto es si el resultado del modal es el encabezado del registro ejecute algo
          if (newv.result.substr(1, 1) === "1") {
            this.textInputs.c1 = newv.data[newv.title[0].cod];
            document.getElementById(newv.result).focus();
          }
        }
      }
    },
    idtoken(newv, oldv) {
      if (newv) {
        this.traeComprobantes(this);
        if (this.cuentas.length === 0) {
          this.traeCuentas(this);
        }
        if (this.nits.length === 0) {
          this.traeNits(this);
        }
        if (this.productos.length === 0) {
          this.traeProductos(this);
        }
        if (this.bodegas.length === 0) {
          this.traeBodegas(this);
        }
        this.traeCCostos(this);
        let temporal = localStorage.getItem("temporal");
        temporal = JSON.parse(temporal);
        if (temporal) {
          this.existborrador = true;
          this.borrador = temporal;
        }
        if (this.hasBoxOfCash) {
          this.findturno();
        }
      }
    },
  },
  components: {
    yEstructura,
    yPrintcomercial,
    yPrintcomercialfactura,
    yEstructurafrapventa,
    yModalcashbox,
  },
};
</script>


<style lang="scss" scoped>
.cashboxbutton {
  bottom: 15px;
  position: fixed;
  z-index: 38;
  right: 15px;
  box-shadow: 5px 0px 13px 3px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
}
</style>






// WEBPACK FOOTER //
// src/components/registrar/Registrar.vue